import { subDays, differenceInWeeks, isValid, format } from 'date-fns';
import { zonedDate, parseMarketingMonth } from './date.js';
import {
  dateFormat,
  defaultDateTimeFormat,
  defaultTimeZone,
  gmt0timezone,
  gmt0timezone as timezone,
} from './constants';
import { formatCurrency, formatPercent } from '@harvestiq/utils';

const defaultDateFormatterOptions = {
  timeZone: defaultTimeZone,
};

/**
 * @deprecated Use `@harvestiq/dayjs` instead.
 */
export const dateFormatter = (date, formatStr = dateFormat, options = {}) => {
  const newDate = isValid(new Date(date)) ? date : parseMarketingMonth(date); // MMM yyyy is not valid date for default Date library

  return format(zonedDate(newDate), formatStr, {
    ...defaultDateFormatterOptions,
    ...options,
  });
};

/**
 * @deprecated Use Decimal from '@harvestiq/utils' instead.
 */
export const limitDecimals = (val, limit = 2) => {
  const numStr = String(val);
  const index = numStr.indexOf('.');
  if (index >= 0) {
    return parseFloat(numStr.slice(0, index + limit + 1));
  }
  return val;
};

/**
 * @deprecated Use Decimal from '@harvestiq/utils' instead.
 */
export const getFormattedFloat = (val, limit = 2) =>
  +limitDecimals(parseFloat(val), limit);

const formatterMap = {
  currency: formatCurrency,
  percent: formatPercent,
  date: dateFormatter,
};

/**
 * @deprecated Use in-place formatters from '@harvestiq/utils' instead.
 */
export const getFormatter =
  (key = 'percent') =>
  (...args) =>
    formatterMap[key](...args);

const formatString = (str, ...args) => `${str}`?.replace(...args);

export const formatPhone = (phone) =>
  formatString(phone, /^(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');

export const formatSSN = (ssn) =>
  formatString(ssn, /^(\d{3})(\d{2})(\d{3})/, '$1-$2-$3');

export const formatEIN = (ein) => formatString(ein, /^(\d{2})(\d{7})/, '$1-$2');

export const tickFormatter = (val) =>
  typeof val === 'number'
    ? formatCurrency(val, { maximumFractionDigits: 0 })
    : '';
